import { h, Fragment } from 'preact';
import clsx from 'clsx';

import Image from '../utils/image';
import MobileMenuList from './mobile-menu-list';

const MobileSubMenuItems = ({
  megaMenus,
  megaMenusBanners,
  activeSubMenuLink = false,
  isVoyagesLayout,
}) => {
  const getBannerImage = ({ image, imageMobile }) => {
    if (isVoyagesLayout) {
      return (
        <Image
          src={imageMobile}
          srcWidths={{
            sm: 640,
            md: 768,
          }}
        />
      );
    }
    return (
      <Image
        src={image}
        srcWidths={{
          sm: 640,
          md: 768,
          lg: 1024,
          xl: 1280,
          '2xl': 1536,
        }}
      />
    );
  };
  const V_BANNER_LINK_CLASS = 'text-[12px] font-light leading-[16px] tracking-[1.2px] font-sackers'
  const V_BANNER_LINK_CLASS_ABS_POSITIONED = 'absolute w-full bottom-5 transform -translate-x-1/2 uppercase before:hidden before:content-[] text-white'

  return (
    <>
      <div className="flex flex-col items-start justify-start w-full">
        {megaMenus?.length > 0 &&
          megaMenus?.map((menuList) => {
            const isFeatured = menuList.handle === 'Featured';
            if (isFeatured) {
              return (
                <div
                  key={menuList.handle}
                  className="p-5 w-full"
                  style={{ order: menuList.index + 30 }}
                >
                  <p
                    className={`font-14-bold ${
                      isVoyagesLayout ? 'text-white' : 'text-black'
                    }  mb-5`}
                  >
                    {menuList.handle}
                  </p>
                  <ul>
                    {menuList.links.length > 0 &&
                      menuList.links.map((link) => (
                        <li key={link.label} className="mb-5">
                          <a
                            href={link.url}
                            className={`font-14 ${
                              isVoyagesLayout ? 'text-white' : 'text-charcoal'
                            }`}
                          >
                            {link.label}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              );
            }
            return (
              <MobileMenuList
                menuList={menuList}
                key={menuList.handle}
                isVoyagesLayout={isVoyagesLayout}
              />
            );
          })}
        {activeSubMenuLink && activeSubMenuLink.url !== '#' && (
          <div className="p-5 order-[20] w-full">
            <div className="bg-cream-grey text-center w-full pt-[18px] pb-5">
              <a
                href={activeSubMenuLink.url}
                className="text-black cta-small uppercase underline"
              >
                {window.TMW?.Strings?.header?.shopAll} {isVoyagesLayout ? "voyages" : activeSubMenuLink.title}
              </a>
            </div>
          </div>
        )}
      </div>
      <div
        className={clsx(
          'flex flex-col items-start justify-start',
          isVoyagesLayout ? 'relative' : 'px-5 pt-5',
        )}
      >
        {megaMenusBanners?.length > 0 &&
          megaMenusBanners?.map((banner) => (
            <div
              key={banner.title}
              className={clsx(
                'w-full text-center',
                banner.image || banner.imageMobile ? '' : 'h-[58px]',
                isVoyagesLayout ? 'relative font-sackers' : 'pb-10 [&_a]:font-13',
              )}
            >
              {banner.url && (
                <a
                  href={banner.url}
                  className={clsx(
                    'block link-unstyled',
                    isVoyagesLayout ? `${V_BANNER_LINK_CLASS}` : 'mb-2.5',
                  )}
                  target={banner.new_tab ? '_blank' : ''}
                  rel="noreferrer"
                >
                  {getBannerImage(banner)}
                </a>
              )}
              {!banner.url && getBannerImage(banner)}
              {banner.title && banner.url && (
                <a
                  href={banner.url}
                  target={banner.new_tab ? '_blank' : ''}
                  className={clsx(
                    'underline',
                    isVoyagesLayout
                      ? `${V_BANNER_LINK_CLASS_ABS_POSITIONED}
                         ${V_BANNER_LINK_CLASS}`
                      : 'text-black block w-fit mx-auto',
                  )}
                  rel="noreferrer"
                >
                  {banner.title}
                </a>
              )}
              {banner.title && !banner.url && (
                <p
                  className={`
                    ${
                      isVoyagesLayout
                        ? `${V_BANNER_LINK_CLASS_ABS_POSITIONED}`
                        : 'text-black block w-fit mx-auto'
                    }`}
                >
                  {banner.title}
                </p>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

export default MobileSubMenuItems;
